var Backbone = require('backbone');
var _ = require('underscore');

require('./Index.less');

var IndexSelect = require('availability/components/IndexSelect/IndexSelect');
var IndexLogin = require('availability/components/IndexLogin/IndexLogin');
var IndexMember = require('availability/components/IndexMember/IndexMember');
var IndexNotMember = require('availability/components/IndexNotMember/IndexNotMember');
var IndexDownload = require('availability/components/IndexDownload/IndexDownload');

module.exports = Backbone.View.extend({

    el: '.Index',

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onUserTypeSelect', 'onLogin', 'onSubmitMember', 'onSubmitNotMember');

        this.indexSelect = new IndexSelect({router: this});
        this.indexLogin = new IndexLogin({router: this});
        this.indexMember = new IndexMember({router: this});
        this.indexNotMember = new IndexNotMember({router: this});
        this.indexDownload = new IndexDownload({router: this});

        this.indexSelect.on('select', this.onUserTypeSelect);
        this.indexLogin.on('login', this.onLogin);
        this.indexMember.on('submit', this.onSubmitMember);
        this.indexNotMember.on('submit', this.onSubmitNotMember);
    },


    onUserTypeSelect: function (tp) {
        this.indexSelect.hide();

        if (tp == 'member') {
            if (!window.app.settings.member) {
                this.indexLogin.show();
            } else {
                this.indexMember.show({memberName: window.app.settings.memberName});
            }
        } else {
            this.indexNotMember.show();
        }
    },


    onLogin: function (data) {
        this.indexLogin.hide();

        window.app.settings.member = data.id;
        window.app.settings.memberName = data.firstName + ' ' + data.lastName;

        this.indexMember.show({memberName: window.app.settings.memberName});
    },


    onSubmitMember: function (data) {
        this.indexMember.hide();

        data.MemberID = window.app.settings.member;

        this.indexDownload.show(data);

        setTimeout(function () {
            this.$el.addClass('Index--lightBg');
        }.bind(this), 300);
    },


    onSubmitNotMember: function (data) {
        this.indexNotMember.hide();

        data.MemberID = 0;

        this.indexDownload.show(data);

        setTimeout(function () {
            this.$el.addClass('Index--lightBg');
        }.bind(this), 300);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/pages/Index/Index.js
// module id = 21
// module chunks = 0